<div class="list">
  <div class="d__flex header">
    <div>
      <h6 class="m-0 heading__">Variants</h6>
      <h6 class="m-0 heading webkit-text" [style.--line]="1">{{product_values.item}}</h6>
    </div>
    <ion-icon (click)="close_modal()" class="mouse" name="close-outline"></ion-icon>
  </div>

  <!-- <div class="box_sec">
    <div [class.active]="item['isActive']" (click)="add_variant(item,i)" *ngFor="let item of product_values.variants;let i = index" class="d__flex mouse boxs">
      <h6 class="m-0 name_">{{item.combination_text}}</h6>
      <ion-icon name="checkmark-circle-outline"></ion-icon>
    </div>
  </div> -->

  <div class="box_sec">

    <div *ngIf="false" class="heading__">
      <h6 class="m-0 bold_name"></h6>
      <ion-checkbox class="check_box" [checked]="check_box_value" labelPlacement="end" (ionChange)="check_box($event,product_values.variants)" >Select all</ion-checkbox>
    </div>

    <div class="d__flex mouse boxs" [class.active]="item['isActive']" (click)="add_variant(item,i)" *ngFor="let item of product_values.variants;let i = index">
      <div *ngIf="false" class="image">
        <img [src]="db.product_img(product_values.product_image)">
      </div>
      <div class="describtion just-s">
        <div class="box_1">
          <h6 class="m-0 bold_name-14">{{product_values.item | titlecase}}</h6>
          <h6 class="m-0 small_name name_">{{item.combination_text}}</h6>
        </div>
      
    <ion-button class="add_btn" fill="clear">{{item['isActive'] ? 'Added' : 'Add'}} 
      <ion-icon *ngIf="item['isActive']" name="checkmark-circle-outline"></ion-icon>
    </ion-button>

      </div>
    </div>
  </div>

  <div class="buttons_div">
    <!-- <ion-button class="close_btn" (click)="close_modal()" fill="clear">Close</ion-button> -->
    <ion-button class="close_btn" (click)="select_all(product_values.variants)" fill="clear">Add All</ion-button>
    <ion-button (click)="save('close')" fill="clear">Proceed</ion-button>

    <!-- <ion-button (click)="save()" fill="clear">Add Variants</ion-button> -->
  </div>

  
  <!-- <ion-footer>
    
  </ion-footer> -->


</div>
